// import { all, call, put, select, take } from 'redux-saga/effects';
import {
  take,
  put,
  call,
  all,
  takeLatest,
  takeEvery,
} from 'redux-saga/effects';
import { commonActions as actions } from '../actions';
import { commonService } from '../services';

function* handleGetSampleRequest() { }
function* handleMessageNotification() {
  let res;
  try {
    res = yield call(commonService.getMessageNotificationApiFun);

    if (res.isError) {
    } else {
      yield put(actions.handleMessageNotificationSuccess(res));
    }
  } catch (error) {
    // yield put(actions.getAttendanceBasicDetailsError());
  }
}


/* Get App Constant Data Sagas */
function* handleGetAppConstantDataRequest() {
  const action = yield take(actions.getAppConstantDataRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(commonService.getAppConstantData, dataParams);
    if (res.isError) {
      yield put(actions.getAppConstantDataError(res));
    } else {
      yield put(actions.getAppConstantDataSuccess(res));
    }
  } catch (error) {
    yield put(actions.getAppConstantDataError());
  }
}

/* Get Date Constant Data Sagas */
function* handleGetDateConstantRequest() {
  const action = yield take(actions.getDateConstantRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(commonService.getDateConstant, dataParams);
    if (res.isError) {
      yield put(actions.getDateConstantError(res));
    } else {
      yield put(actions.getDateConstantSuccess(res));
    }
  } catch (error) {
    yield put(actions.getDateConstantError());
  }
}

/* Get Constant By Category Subcategory Sagas */
function* handleGetConstantByCategorySubcategoryRequest() {
  const action = yield take(actions.getConstantByCategorySubcategoryRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(commonService.getConstantByCategorySubcategory, dataParams);
    if (res.isError) {
      yield put(actions.getConstantByCategorySubcategoryError(res));
    } else {
      yield put(actions.getConstantByCategorySubcategorySuccess(res));
    }
  } catch (error) {
    yield put(actions.getConstantByCategorySubcategoryError());
  }
}

/* Get Constant By Category Subcategory Sagas */
function* handleCheckInCheckOutMachineRequest() {
  const action = yield take(actions.checkInCheckOutMachineRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(commonService.checkInCheckOutMachine, dataParams);
    if (res.isError) {
      yield put(actions.checkInCheckOutMachineError(res));
    } else {
      yield put(actions.checkInCheckOutMachineSuccess(res));
    }
  } catch (error) {
    yield put(actions.checkInCheckOutMachineError());
  }
}


/* -----------Watchers------------- */
function* handleMessageNotificationWatcher() {
  yield takeEvery(
    actions.handleMessageNotificationRequest,
    handleMessageNotification,
  );
}

function* handleGetAppConstantDataWatcher() {
  yield takeEvery(
    actions.getAppConstantDataRequest,
    handleGetAppConstantDataRequest,
  );
}

function* handleGetConstantByCategorySubcategoryWatcher() {
  yield takeEvery(
    actions.getConstantByCategorySubcategoryRequest,

    handleGetConstantByCategorySubcategoryRequest,
  );
}



function* handleGetDateConstantWatcher() {
  yield takeEvery(
    actions.getDateConstantRequest,
    handleGetDateConstantRequest,
  );
}

function* handleCheckInCheckOutMachineWatcher() {
  yield takeEvery(
    actions.checkInCheckOutMachineRequest,
    handleCheckInCheckOutMachineRequest,
  );
}

function* rootCommonSaga() {
  yield all([
    handleGetSampleRequest(),
    handleMessageNotification(),
    handleMessageNotificationWatcher(),

    handleGetAppConstantDataRequest(),
    handleGetAppConstantDataWatcher(),

    handleGetDateConstantRequest(),
    handleGetDateConstantWatcher(),
    handleGetConstantByCategorySubcategoryRequest(),
    handleGetConstantByCategorySubcategoryWatcher(),

    handleCheckInCheckOutMachineRequest(),
    handleCheckInCheckOutMachineWatcher(),
  ]);
}

export default rootCommonSaga;
